export const links = [
    {
      photo: "https://res.cloudinary.com/middle-renaissance-realty-llc/image/upload/c_scale,w_750/v1787266196/Screenshot_2026-08-20_at_5.49.27_PM_lieqve.png",
      // photo: "../images/DCOpenHouse.gif",
      url:"https://joinbookbuddy.com",
      title: "BookBuddy",
      images:[
        "https://res.cloudinary.com/middle-renaissance-realty-llc/image/upload/c_scale,w_750/v1787448295/Screenshot_2026-08-22_at_8.24.12_PM_krzlbt.png",
        "https://res.cloudinary.com/middle-renaissance-realty-llc/image/upload/c_scale,w_750/v1787448144/Screenshot_2026-08-22_at_8.21.47_PM_ut0bjd.png",
        "https://res.cloudinary.com/middle-renaissance-realty-llc/image/upload/c_scale,w_140/v1787263314/Screenshot_2026-08-20_at_4.57.30_PM_lgnegn.png",
      ],
      big_images:[
        "https://res.cloudinary.com/middle-renaissance-realty-llc/image/upload/c_scale,w_750/v1787448295/Screenshot_2026-08-22_at_8.24.12_PM_krzlbt.png",
        "https://res.cloudinary.com/middle-renaissance-realty-llc/image/upload/c_scale,w_750/v1787448144/Screenshot_2026-08-22_at_8.21.47_PM_ut0bjd.png",
        "https://res.cloudinary.com/middle-renaissance-realty-llc/image/upload/c_scale,w_550/v1787263314/Screenshot_2026-08-20_at_4.57.30_PM_lgnegn.png",
      ],
      text:[
        "Full stack book club app built with Angular, .NET Core, and SQL Server. Deployed on AWS (S3 frontend, EC2 for API, Docker for SQL Server) with a full CI/CD pipeline. Features backend OAuth login flow, friend connections, instant messaging.",
        "Full stack book club app built with Angular, .NET Core, and SQL Server. Deployed on AWS (S3 frontend, EC2 for API, Docker for SQL Server) with a full CI/CD pipeline. Features backend OAuth login flow, friend connections, instant messaging.",
        "Full stack book club app built with Angular, .NET Core, and SQL Server. Deployed on AWS (S3 frontend, EC2 for API, Docker for SQL Server) with a full CI/CD pipeline. Features backend OAuth login flow, friend connections, instant messaging."
      ],
      github:'https://github.com/CloudEntity57/BookBuddy'
  },
  {
      photo: "http://res.cloudinary.com/middle-renaissance-realty-llc/image/upload/c_scale,w_750/v1501533478/DC_6_irbfjo.png",
      // photo: "../images/DCOpenHouse.gif",
      url:"http://joshfoster.tech",
      title: "DC's Open House List (No longer online)",
      images:[
        "http://res.cloudinary.com/middle-renaissance-realty-llc/image/upload/c_scale,w_140/v1501533478/DC_6_irbfjo.png",
        "http://res.cloudinary.com/middle-renaissance-realty-llc/image/upload/c_scale,w_140/v1507415780/DC_7_udtxel.png",
        "http://res.cloudinary.com/middle-renaissance-realty-llc/image/upload/c_scale,w_140/v1507415852/DC_8_vube09.png",
        "http://res.cloudinary.com/middle-renaissance-realty-llc/image/upload/c_scale,w_140/v1507433252/DC_9_pxdm4t.png"
      ],
      big_images:[
        "http://res.cloudinary.com/middle-renaissance-realty-llc/image/upload/c_scale,w_550/v1501533478/DC_6_irbfjo.png",
        "http://res.cloudinary.com/middle-renaissance-realty-llc/image/upload/c_scale,w_550/v1507415780/DC_7_udtxel.png",
        "http://res.cloudinary.com/middle-renaissance-realty-llc/image/upload/c_scale,w_550/v1507415852/DC_8_vube09.png",
        "http://res.cloudinary.com/middle-renaissance-realty-llc/image/upload/c_scale,w_550/v1507433252/DC_9_pxdm4t.png"
      ],
      text:[
        "Fully IDX integrated real estate searching/mapping app built on React/Express.",
        "Searches Washington DC area for open houses and maps them. Integrates API data from the Washington DC MLS feed.",
        "Maps by day, sorts by price, time, days on market.",
        "Features photo carousel, contact form, custom CSS animated buttons."
      ],
      github:'https://github.com/CloudEntity57/DC-Open-House_List'
  },
      {
        photo: "https://res.cloudinary.com/middle-renaissance-realty-llc/image/upload/c_scale,w_750/v1767741278/WYRDLE-pic_bevgt2.png",
        // photo: "../images/DCOpenHouse.gif",
        url:"https://main.wyrdle-dri.pages.dev/",
        title: "Wordle Clone (Feb 2022)",
        images:[
          "https://res.cloudinary.com/middle-renaissance-realty-llc/image/upload/v1767741278/WYRDLE-pic_bevgt2.png",
          "https://res.cloudinary.com/middle-renaissance-realty-llc/image/upload/v1644255266/Wyrdle_example_krrpcv.png"
        ],
        big_images:[
          "https://res.cloudinary.com/middle-renaissance-realty-llc/image/upload/w_1000,ar_1:1,c_fill,g_auto,e_art:hokusai/v1767741278/WYRDLE-pic_bevgt2.png",
          "https://res.cloudinary.com/middle-renaissance-realty-llc/image/upload/v1644255266/Wyrdle_example_krrpcv.png",
        ],
        text:[
          "A clone of Wordle I built in Angular 13, well before AI coding tools could do it.", 
          "Lets the user pick the number of letter words to solve and whether or not to have unlimited tries."
        ],
        github:'https://github.com/CloudEntity57/Wyrdle'
    },
    {
        photo: "http://res.cloudinary.com/middle-renaissance-realty-llc/image/upload/c_scale,w_750/v1501533478/DC_6_irbfjo.png",
        // photo: "../images/DCOpenHouse.gif",
        url:"https://triego-ce72e.firebaseapp.com/",
        title: "Trieggo's Italian",
        images:[
          "http://res.cloudinary.com/middle-renaissance-realty-llc/image/upload/c_scale,w_140/v1507921790/Triegos4_z1ptel.jpg",
          "http://res.cloudinary.com/middle-renaissance-realty-llc/image/upload/c_scale,w_140/v1507921619/Triegos2_cgye5b.jpg",
          "http://res.cloudinary.com/middle-renaissance-realty-llc/image/upload/c_scale,w_140/v1507921621/Triegos3_wj0jgm.jpg"
        ],
        big_images:[
          "http://res.cloudinary.com/middle-renaissance-realty-llc/image/upload/c_scale,w_950/v1507921790/Triegos4_z1ptel.jpg",
          "http://res.cloudinary.com/middle-renaissance-realty-llc/image/upload/c_scale,w_950/v1507921619/Triegos2_cgye5b.jpg",
          "http://res.cloudinary.com/middle-renaissance-realty-llc/image/upload/c_scale,w_950/v1507921621/Triegos3_wj0jgm.jpg"
        ],
        text:[
          "Front end build for Italian restaurant. Uses CSS3 transitions. Frameworks: React, SASS, jQuery.",
          "Page detects scrolling events, triggering CSS3 screen animations and fade-ins for an eye-catching user experience.",
          "One of my favorite aspects of web development is continually pushing the limits of front end tools."
        ],
        github:'https://github.com/CloudEntity57/Trieggos-Italian'
    },
    {
        photo: "http://res.cloudinary.com/middle-renaissance-realty-llc/image/upload/c_scale,w_750/v1522875689/MovieTron_n3kqwx.png",
        // photo: "../images/DCOpenHouse.gif",
        url:"https://movietron-2026.web.app",
        title: "MovieTron - a Clone of Netflix UI",
        images:[
          "http://res.cloudinary.com/middle-renaissance-realty-llc/image/upload/c_scale,w_140/v1522875689/MovieTron_n3kqwx.png",
          "http://res.cloudinary.com/middle-renaissance-realty-llc/image/upload/c_scale,w_140/v1522876230/MovieTron2_fjgqas.png"
        ],
        big_images:[
          "http://res.cloudinary.com/middle-renaissance-realty-llc/image/upload/c_scale,w_950/v1522875689/MovieTron_n3kqwx.png",
          "http://res.cloudinary.com/middle-renaissance-realty-llc/image/upload/c_scale,w_950/v1522876230/MovieTron2_fjgqas.png"
        ],
        text:[
          "Front end recreation of the Netflix UI environment; most notably the sliding video boxes. Frameworks: React, SASS, jQuery.",
          "Created as an experiment to recreate a popular site by eye alone, without referring to the site's source code."
        ],
        github:'https://github.com/CloudEntity57/Netflix-Clone'
    },
   {
       photo: "http://res.cloudinary.com/middle-renaissance-realty-llc/image/upload/c_scale,w_564/v1489470677/Untitled_picture_c8abxv.jpg",
       url:"https://smartset-7a283.firebaseapp.com/",
       title: "SmartSet",
       images:[
         "http://res.cloudinary.com/middle-renaissance-realty-llc/image/upload/c_scale,w_140/v1507569883/SmartSet0_aqegmh.png",
         "http://res.cloudinary.com/middle-renaissance-realty-llc/image/upload/c_scale,w_140/v1507576994/SmartSet6_tqmcic.png",
         "http://res.cloudinary.com/middle-renaissance-realty-llc/image/upload/c_scale,w_140/v1507569890/SmartSet2_otvzjs.png",
         "http://res.cloudinary.com/middle-renaissance-realty-llc/image/upload/c_scale,w_140/v1507569887/SmartSet1_wnm6d7.png",
         "http://res.cloudinary.com/middle-renaissance-realty-llc/image/upload/c_scale,w_140/v1507569898/SmartSet3_wn9zqm.png",
         "http://res.cloudinary.com/middle-renaissance-realty-llc/image/upload/c_scale,w_140/v1507569911/SmartSet4_iridi9.png"
       ],
       big_images:[
         "http://res.cloudinary.com/middle-renaissance-realty-llc/image/upload/c_scale,w_550/v1507569883/SmartSet0_aqegmh.png",
         "http://res.cloudinary.com/middle-renaissance-realty-llc/image/upload/c_scale,w_550/v1507576994/SmartSet6_tqmcic.png",
         "http://res.cloudinary.com/middle-renaissance-realty-llc/image/upload/c_scale,w_550/v1507569890/SmartSet2_otvzjs.png",
         "http://res.cloudinary.com/middle-renaissance-realty-llc/image/upload/c_scale,w_550/v1507569887/SmartSet1_wnm6d7.png",
         "http://res.cloudinary.com/middle-renaissance-realty-llc/image/upload/c_scale,w_550/v1507569898/SmartSet3_wn9zqm.png",
         "http://res.cloudinary.com/middle-renaissance-realty-llc/image/upload/c_scale,w_550/v1507569911/SmartSet4_iridi9.png"
       ],
       text:[
         "Project in React.js and Firebase that stores a user's songs and automatically generates performances of different lengths and set numbers, according to desired genres.",
         "Add custom chords to songs and specify song genre tags for easy classification later.",
         "User's songs are stored in a central database where they can be accessed as individual React components.",
         "Lyrics and guitar chords are displayed, and anything can be edited at any time, all modular and fast-loading with React.",
         "Built in JavaScript algorithms allow a user to automatically compile a long show with blues songs, or a short show with upbeat songs.",
         "When it's time to perform, gigs are viewed on a customizable dashboard that scrolls the songs in order."
       ],
       github:'https://github.com/CloudEntity57/SmartSet'
   },
  //  {
  //      photo: "http://res.cloudinary.com/middle-renaissance-realty-llc/image/upload/c_scale,w_563/v1497474684/CouchPolitics_rt2ufw.png",
  //      url:"https://couchpolitics.herokuapp.com/",
  //      title: "Cloudergy",
  //      images:[
  //        "http://res.cloudinary.com/middle-renaissance-realty-llc/image/upload/c_scale,w_140/v1507576324/Cloudergy5_gkbzoi.png",
  //        "http://res.cloudinary.com/middle-renaissance-realty-llc/image/upload/c_scale,w_140/v1507575977/Cloudergy2_ashrl5.png",
  //        "http://res.cloudinary.com/middle-renaissance-realty-llc/image/upload/c_scale,w_140/v1507575981/Cloudergy3_pjiafk.png",
  //        "http://res.cloudinary.com/middle-renaissance-realty-llc/image/upload/c_scale,w_140/v1507575984/Cloudergy4_o09zzy.png"
  //  ],
  //      big_images:[
  //        "http://res.cloudinary.com/middle-renaissance-realty-llc/image/upload/c_scale,w_550/v1507576324/Cloudergy5_gkbzoi.png",
  //        "http://res.cloudinary.com/middle-renaissance-realty-llc/image/upload/c_scale,w_550/v1507575977/Cloudergy2_ashrl5.png",
  //        "http://res.cloudinary.com/middle-renaissance-realty-llc/image/upload/c_scale,w_550/v1507575981/Cloudergy3_pjiafk.png",
  //        "http://res.cloudinary.com/middle-renaissance-realty-llc/image/upload/c_scale,w_550/v1507575984/Cloudergy4_o09zzy.png"
  //      ],
  //      text:[
  //        "Facebook clone built with React/Redux MERN stack. Imitates core FB functionality. User posts, comments, likes, pages, friend-making. Includes link sharing, privacy settings and more.",
  //        "Personal user pages can detect friends and lets them make posts.",
  //        "Posts have privacy settings, app does meta scraping of shared URL for image, page title and description so the actual post provides an image/text link instead of an http address."
  //      ]
  //    },
     {
         photo: "http://res.cloudinary.com/middle-renaissance-realty-llc/image/upload/v1475689200/Allen_Brothers_cl4nrz.jpg",
         url: "http://allenb.com",
         title: "Allen Brothers Commercial Site",
         images:[],
         big_images:["http://res.cloudinary.com/middle-renaissance-realty-llc/image/upload/v1475689200/Allen_Brothers_cl4nrz.jpg"],
         text:[
           "Custom PHP Wordpress template for real estate brokerage"
         ],
         github:'https://github.com/CloudEntity57/Allen_Brothers_WP_Theme/tree/master'
     },
    // {
    //     photo: "http://res.cloudinary.com/middle-renaissance-realty-llc/image/upload/c_scale,w_544/v1491262402/SpotifyBrowser_f8qpax.png",
    //     url: "http://spotifybrowser.firebaseapp.com",
    //     title: "Spotify Speed Browser (now requires auth)",
    //     images:[],
    //     big_images:["http://res.cloudinary.com/middle-renaissance-realty-llc/image/upload/c_scale,w_544/v1491262402/SpotifyBrowser_f8qpax.png"],
    //     text:[
    //       "Single page React.js/Firebase app browses Spotify by artist, displays albums/tracks, plays sample clips, and allows album toggling. Navigation using browser back button enabled with React Router."
    //     ]
    // },
    // {
    //     photo: "http://res.cloudinary.com/middle-renaissance-realty-llc/image/upload/c_scale,h_327/v1495221822/Redux_Leaflet_gj7xpa.png",
    //     url: "https://reduxleafletapp.firebaseapp.com/",
    //     title: "Redux Leaflet App",
    //     images:[],
    //     big_images:["http://res.cloudinary.com/middle-renaissance-realty-llc/image/upload/c_scale,h_327/v1495221822/Redux_Leaflet_gj7xpa.png"],
    //     text:[
    //       "React/Redux single page app that connects to the Leaflet Maps API using React-Leaflet.js and components from the Material-UI library."
    //     ],
    //     github:'https://github.com/CloudEntity57/My_Redux_Leaflet_App'
    // },
    // {
    //     photo: "http://res.cloudinary.com/middle-renaissance-realty-llc/image/upload/v1487626184/GistAlt_cbtify.png",
    //     url: "https://notesapp-edb56.firebaseapp.com",
    //     title: "Developer Notes Tool",
    //     images:[],
    //     big_images:["http://res.cloudinary.com/middle-renaissance-realty-llc/image/upload/v1487626184/GistAlt_cbtify.png"],
    //     text:[
    //       "(Team project) A searchable database of all your individual notes appears when you log in, and it's easy to assign web-related color categories to notes as you create them. Built with React.js and Firebase."
    //     ]
    // },
    //{
      //  photo: "http://res.cloudinary.com/middle-renaissance-realty-llc/image/upload/v1484279891/Web_Shot2_qeptqh.png",
        //url: "https://cryptic-peak-65100.herokuapp.com/",
       // title: "Favorite Albums Bulletin Board",
        //text:"Online UI database where a user's favorite albums can be stored/displayed via a RESTful CRUD database built with Express.js and MongoDB."
   // },
//    {
  //      photo: "http://res.cloudinary.com/middle-renaissance-realty-llc/image/upload/v1475689308/Heliowire_xsw4a7.jpg",
    //    url: "https://frozen-journey-83037.herokuapp.com/index.php",
      //  title: "Heliowire.com",
        // text:"PHP driven responsive template for a solar energy news hub. Currently connects to Reddit Solar News API and displays the latest feed."
   // },
    {
        photo: "http://res.cloudinary.com/middle-renaissance-realty-llc/image/upload/v1487829847/clouds_lvmllc.png",
        url: "/3x+1/3x+1.htm",
        title: "Collatz Conjecture",
        images:[],
        big_images:["http://res.cloudinary.com/middle-renaissance-realty-llc/image/upload/v1487829847/clouds_lvmllc.png"],
        text:["Simple single page application allowing users to plot the iterations of a particular mathematical function. JavaScript, jQuery & Bootstrap."],
        github:''
    },
    // {
    //     photo: "http://res.cloudinary.com/middle-renaissance-realty-llc/image/upload/v1484190674/Web_shot_bz0men.png",
    //     url: "https://limitless-reaches-19249.herokuapp.com",
    //     title: "Pencil, Paper, Scissors",
    //     text:"Site built with Node.js and Express.js - RESTful MongoDB database, along with search feature that connects to the Amazon API with AJAX and saves shopping lists in real time with AJAX POST requests."
    // },
    // {
    //     photo: "http://res.cloudinary.com/middle-renaissance-realty-llc/image/upload/v1475689267/Houston_TX_empn2d.jpg",
    //     url: "http://allenbrothersrealtors.com/Home",
    //     title: "Allen Brothers Residential Site",
    //     images:[],
    //     big_images:["http://res.cloudinary.com/middle-renaissance-realty-llc/image/upload/v1475689267/Houston_TX_empn2d.jpg"],
    //     text:["Existing CMS website cleaned up and made professional with jQuery and JavaScript DOM manipulation on the front end. Full mobile responsivity added with Bootstrap and raw CSS; previously unusable."],
    //     github:''
    // }
    // {
    //     photo: "http://res.cloudinary.com/middle-renaissance-realty-llc/image/upload/v1476122562/IMG_5141-compressed_eorbdj.jpg",
    //     url: "http://allenbrothersrealtors.com/Home",
    //     title: "Coming Soon",
    //     images:[],
    //     big_images:["http://res.cloudinary.com/middle-renaissance-realty-llc/image/upload/v1476122562/IMG_5141-compressed_eorbdj.jpg"],
    //     text:["Many more projects in the works at all times!"]
    // }
];



// WEBPACK FOOTER //
// ./src/components/js/projects.js